// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-Q_MhxN{flex-shrink:0;justify-content:flex-start;align-self:stretch;align-items:center;width:24px;height:24px;margin-left:8px;display:flex}.container-Q_MhxN .icon-no-uz4u09{align-items:center;display:flex}.container-Q_MhxN .icon-no-uz4u09 .icon-AFTo5d{cursor:pointer;color:#888d92;width:20px;height:20px}.container-Q_MhxN .icon-no-uz4u09 .icon-AFTo5d.disabled-YksBvb{cursor:not-allowed}.container-Q_MhxN .icon-no-uz4u09 .icon-AFTo5d>svg{width:20px;height:20px}.container-Q_MhxN .add-dhS6yw{color:#4d53e8;cursor:pointer;margin-left:8px;font-size:12px;font-style:normal;font-weight:600;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container-Q_MhxN`,
	"icon-no": `icon-no-uz4u09`,
	"iconNo": `icon-no-uz4u09`,
	"icon": `icon-AFTo5d`,
	"disabled": `disabled-YksBvb`,
	"add": `add-dhS6yw`
};
export default ___CSS_LOADER_EXPORT___;
